import BigNumber from 'bignumber.js'

import { Order } from '@blade/std-lib'

import type { HoldersChartEntryDto } from '@root/shared/api/TradeApi'

export interface HoldersChartEntry {
  value: BigNumber
  date: Date
}

export const fromDto = (dto: HoldersChartEntryDto): HoldersChartEntry => ({
  value: BigNumber(dto.value),
  date: new Date(dto.timestamp),
})

export const cmpByDate = Order.mapInput(
  Order.Date,
  (x: HoldersChartEntry) => x.date,
)
